<template>

  <img src="../../static/img/aihaozhe_shouhoutongzhi.png" v-show="isFan" class="content_wrap" :style="{height: imageHeight + 'px'}"/>

  <img src="../../static/img/shouhoutongzhi_wenshenshi.png" v-show="!isFan" class="content_wrap2" :style="{height: imageHeight2 + 'px'}"/>
</template>

<script type="text/babel">
  export default {
    data() {
      return {
        desc: [],
        isFan: false,
        imageHeight: window.screen.width *  2362 / 750,
        imageHeight2: window.screen.width *  2362 / 750,
      };
    },
    ready() {
      if (this.$route.query.fans) {
        this.isFan = true;
      } else{
        this.isFan = false;
      }

    },
    methods: {}
  }
</script>

<style scoped>

  .space {
    color: #e6e6e6;
    margin-top: 15px;
    background-color: #ddd;
    border: 0;
    height: 1px;
  }

  .content_wrap {
    /*margin-left: 53px;*/
    /*margin-right: 10px;*/
    width: 100%;
  }

  .content_wrap2 {
    /*margin-left: 53px;*/
    /*margin-right: 10px;*/
    width: 100%;
  }

  .subTitle {
    font-size: 14px;
    line-height: 42px;
    height: 42px;
    position: relative;
  }

  .subTitle img {
    position: absolute;
    width: 29px;
    left: -40px;
    top: 4px;
  }

  .mainTitle {
    font-size: 16px;
    text-align: center;
    height: 70px;
    line-height: 70px;
  }

  .content {
    font-size: 12px;
    color: #828282;
    line-height: 1.6;
  }

  .content:last-child {
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// service.vue?48996e29